import React, {useEffect} from "react";

import './AlarmEventsTable.scss'
import {
  DataTable,
  DataTableSkeleton,
  Table,
  TableBody,
  TableCell, TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Theme
} from "@carbon/react";
import {useRecoilState, useRecoilValue} from "recoil";
import {errorStateFamily, loadingStateFamily, rowsStateFamily} from "../../../state/alarm_events_table";
import {grpcEventServiceSelector} from "../../../state/grpc";

const AlarmEventsTable = (props) => {
  const headers = [
    {
      key: 'name',
      header: 'Nome',
    },
    {
      key: 'description',
      header: 'Descrizione',
    },
    {
      key: 'datetime',
      header: 'Data e ora',
    },
    {
      key: 'username',
      header: 'Utente',
    },
  ];
  const alarmId = props.alarmId
  const [loading, setLoading] = useRecoilState(loadingStateFamily(alarmId))
  const [error, setError] = useRecoilState(errorStateFamily(alarmId))
  const [rows, setRows] = useRecoilState(rowsStateFamily(alarmId))
  const eventService = useRecoilValue(grpcEventServiceSelector)

  async function getAlarmEventsTableData() {
    const req = new proto.api.ListEventsRequest();
    req.setModel("alarms")
    req.setModelId(alarmId)
    setLoading(true)
    eventService.listEvents(req, null, (err, resp) => {
      if (err != null) {
        setError(true)
      } else {
        setRows(resp.toObject().eventsList)
      }
      setLoading(false)
    })
  }

  useEffect(() => {
    getAlarmEventsTableData();
  }, [eventService, setError, setLoading, setRows]);

  if (loading) {
    return (
      <DataTableSkeleton
        columnCount={headers.length + 1}
        rowCount={2}
        headers={headers}
      />
    )
  }

  if (error) {
    return (
      <div>
        <span>ERROR!</span>
      </div>
    )
  }

  return (
    <Theme theme="g10">
      <DataTable
        rows={rows}
        headers={headers}
        isSortable
        render={({
                   rows,
                   headers,
                   getHeaderProps,
                   getRowProps,
                   getTableProps,
                   getTableContainerProps,
                 }) => {
          return (
            <TableContainer {...getTableContainerProps()}>
              <Table {...getTableProps()}>
                <TableHead>
                  <TableRow>
                    {headers.map((header) => (<TableHeader {...getHeaderProps({header})}>
                      {header.header}
                    </TableHeader>))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row.id} {...getRowProps({row})}>
                      {row.cells.map((cell) => (
                        <TableCell className="alarm-events-table__cell" key={cell.id}>{cell.value}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          );
        }}
      />
    </Theme>
  )
}

export default AlarmEventsTable